import React, { Component } from 'react';
import PropTypes from 'prop-types'; // ES6
import { Input } from 'antd';

const { TextArea } = Input;

class VariableText extends Component {

    render() {
        const { estilsDiv, variable } = this.props;

        return (
            <div className={estilsDiv}>
                {variable.nom}
                <TextArea
                    autosize={{ minRows: 2, maxRows: 1 }}
                    onBlur={(event) => this.props.onChangeValorVariable(event.target.value || undefined)}
                    defaultValue={variable.valor} />
            </div>
        );
    }
}

VariableText.propTypes = {
    estilsDiv: PropTypes.string,
    variable: PropTypes.object,
    onChangeValorVariable: PropTypes.func
};

export default VariableText;



// WEBPACK FOOTER //
// ./src/components/commons/variableText.js